import React from 'react';
import PropTypes from 'prop-types';
import fuzzyFilterFactory from 'react-fuzzy-filter';
import { Popover } from '@saucelabs/sl-component-overlay';
import { ControlLabel, FormGroup } from '@saucelabs/sl-component-form';
import { ListGroup, ListGroupItem } from '@saucelabs/sl-component-list-group';

import Styles from './OwnersPopover.styles';

const { InputFilter, FilterResults } = fuzzyFilterFactory();
const searchConfig = {
  keys: ['label'],
  threshold: 0.15,
};

const OwnersPopover = ({ owners, ownership, selectOwner, username }) => (
  <Popover
    id="filter-owners-popover"
    placement="bottom"
  >
    <div className={Styles.default}>
      <FormGroup>
        <ControlLabel>LIMIT RESULTS BY OWNER</ControlLabel>
        <InputFilter
          inputProps={{
            className: 'form-control',
            placeholder: 'Search owners...',
          }}
        />
        <FilterResults
          fuseConfig={searchConfig}
          items={owners}
        >
          {(filteredOwners) => (
            <ListGroup className={Styles.list}>
              {filteredOwners.map((owner) => (
                <ListGroupItem
                  key={owner.name}
                  active={ownership.name === owner.name || (!ownership && owner.name === username)}
                  className={Styles['list-item']}
                  onClick={() => selectOwner(owner)}
                >
                  {owner.label || owner.name}
                </ListGroupItem>
              ))}
            </ListGroup>
          )}
        </FilterResults>
      </FormGroup>
    </div>
  </Popover>
);

OwnersPopover.propTypes = {
  owners: PropTypes.array.isRequired,
  ownership: PropTypes.object.isRequired,
  selectOwner: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
};

export default OwnersPopover;
